import { render, staticRenderFns } from "./SubscriberForm.vue?vue&type=template&id=3fb336fa&"
import script from "./SubscriberForm.vue?vue&type=script&lang=ts&"
export * from "./SubscriberForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports